<template>
  <header>
    <div class="header-container">
      <div class="header-content">
        <!-- Logo e Nome -->
        <div class="logo-section">
          <div class="logo">
            <router-link to="/dashboard" aria-label="Ir para Home">
              <img :src="logoUrl" alt="LWSA" width="28" height="28" />
            </router-link>
          </div>
          <div class="logo-text">
            <h1>LWSA</h1>
            <p>Developer Portal</p>
          </div>
        </div>

        <!-- Menu do usuário -->
        <div v-if="isAuthenticated" class="user-menu">
          <span>{{ user?.name || user?.email }}</span>
          <button @click="handleLogout" class="btn-logout">
            Logout
          </button>
        </div>
        
        <LoginButton v-else />
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth.js'
import LoginButton from '@/components/auth/LoginButton.vue'
import logoUrl from '@/assets/faviconLwsa.ico'

const authStore = useAuthStore()

// Garantir que o authStore seja inicializado
onMounted(() => {
  authStore.initializeAuth()
})

// Computadas reativas para o estado de autenticação
const isAuthenticated = computed(() => authStore.isAuthenticated)
const user = computed(() => authStore.user)

const handleLogout = async () => {
  try {
    console.log('Iniciando logout...')
    await authStore.logout()
    console.log('Logout concluído')
  } catch (error) {
    console.error('Erro no logout:', error)
  }
}
</script>